module.exports = __webpack_public_path__ + "img/box1.a63017d2.svg";